import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReportsIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 13,
	height: 14,
	viewBox: "0 0 13 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.5556 0.5C11.92 0.499878 12.271 0.645605 12.5382 0.907968C12.8054 1.17033 12.9691 1.52994 12.9964 1.91471L13 2.02941V11.9706C13.0001 12.3564 12.8625 12.7281 12.6147 13.011C12.3669 13.2939 12.0273 13.4672 11.6639 13.4962L11.5556 13.5H1.44444C1.08003 13.5001 0.729035 13.3544 0.461827 13.092C0.194618 12.8297 0.0309425 12.4701 0.00361127 12.0853L7.24158e-08 11.9706V2.02941C-0.000115252 1.64356 0.137516 1.27192 0.385303 0.988993C0.633091 0.706066 0.972721 0.532763 1.33611 0.503824L1.44444 0.5H11.5556ZM3.61111 9.67647H1.44444V11.9706H3.61111V9.67647ZM11.5556 9.67647H5.05556V11.9706H11.5556V9.67647ZM3.61111 5.85294H1.44444V8.14706H3.61111V5.85294ZM11.5556 5.85294H5.05556V8.14706H11.5556V5.85294ZM3.61111 2.02941H1.44444V4.32353H3.61111V2.02941ZM11.5556 2.02941H5.05556V4.32353H11.5556V2.02941Z",
		fill: "current"
	})]
});
const ForwardRef = forwardRef(SvgReportsIcon);
export { ForwardRef as ReactComponent };
